import { useContext } from "react";

import { ViewportContext } from "@/components/viewport-provider/viewport-provider-component";

export default function useViewportContext() {
  return useContext(ViewportContext);
}
